export const EN_US = {

  'header': 'Paragraph Formatting',
  'normal': 'Normal',
  'h1': 'Heading 1',
  'h2': 'Heading 2',
  'h3': 'Heading 3',
  'h4': 'Heading 4',
  'h5': 'Heading 5',
  'h6': 'Heading 6',

  'lineheight': 'Line Height',
  'songti': 'SimSun',
  'yahei': 'Microsoft Yahei',
  'kaiti': 'KaiTi',
  'heiti': 'SimHei',
  'lishu': 'LiSu',

  'left': 'Left',
  'center': 'Centered',
  'right': 'Right',

  'codeblock': 'Code Block',
  'globallink': 'Link',

  'exit-fullscreen': 'Exit Full Screen',
  'help': 'Help',
  'more': 'More',

  'help-format': 'Format',
  'help-insert': 'Insert',
  'help-operation': 'Edit',
  'mention': 'Mention People',
  'quick-menu': 'Shortcut',
  'toggle-help-panel': 'Open/Close Help Panel',
  'scroll-table': 'Horizontal Scroll',
  'mouse-wheel': 'Mouse Wheel',
  'save': 'Save',

  'copy-cells': 'Copy',
  'copy-table': 'Copy Table',
  'cut-cells': 'Cut',
  'empty-cells': 'Clear Contents',

  'insert-row-up': 'Insert Rows Above',
  'insert-row-down': 'Insert Rows Below',
  'insert-column-left': 'Insert Columns to the Left',
  'insert-column-right': 'Insert Columns to the Right',

  'merge-cells': 'Merge Cells',
  'unmerge-cells': 'Split Cells',

  'delete-row': 'Delete Entire Row',
  'delete-column': 'Delete Entire Column',
  'delete-table': 'Delete Table',

  'default-link-text': 'Link',
  'basicblock': 'Card',
  'linkplaceholder': 'Enter an address and press Enter.',
  'counter-template': `{{count}}/{{totalCount}} {{countUnit}}`,
  'char': 'characters',
  'word': 'words',
  'counter-limit-tips':
    'The number of {{countUnit}} exceeds the maximum allowed limit.',
  'ie-msg':
    'In order to have a better experience, it is recommended to use the latest version of Chrome browser.',

  'loading': 'Loading...',
  'pasting': 'A large amount of content to paste. Loading...',
  'img-error': 'Image Copy Error',
  'img-error-info':
    'Failed to copy the image. Save it to your local computer and then upload it by clicking Image on the toolbar.',

  'last-modified': 'Last Modified Date:',
  'screenshot': 'Screenshot',
  'uploading': 'Uploading...',
  'sub-title-bg-color': 'Background Color',

  // blot tip name
  'emoji': 'Emoji',
  'fullscreen': 'Full Screen',
  'blockquote': 'Quote',
  'undo': 'Undo',
  'redo': 'Redo',
  'clean': 'Clear Formatting',
  'bold': 'Bold',
  'italic': 'Italic',
  'underline': 'Underline',
  'strike': 'Strikethrough',
  'image': 'Image',
  'file': 'File',
  'table': 'Table',
  'link': 'Hyperlink',
  'code': 'Inline Code',
  'better-table': 'Table',
  'code-block': 'Code Block',
  'formula': 'Formula',
  'format-painter': 'Format Painter',
  'divider': 'Divider',
  'video': 'Video',
  'color': 'Font Color',
  'background': 'Background Color',
  'font': 'Font',
  'size': 'Size',
  'list-ordered': 'Ordered List',
  'list-bullet': 'Unordered List',
  'list-check': 'Task List',
  'align-left': 'Left aligned',
  'align-center': 'Center aligned',
  'align-right': 'Right aligned',
  'align-justify': 'Justify aligned',
  'direction-ltr': 'Text Direction Left To Right',
  'direction-rtl': 'Text Direction Right To Left',
  'indent--1': 'Minus Indent',
  'indent-+1': 'Add Indent',
  'script-super': 'Superscript',
  'script-sub': 'Subscript',
  'header-normal': 'Text',
  'header-1': 'Heading 1',
  'header-2': 'Heading 2',
  'header-3': 'Heading 3',
  'header-4': 'Heading 4',
  'header-5': 'Heading 5',
  'header-6': 'Heading 6',
  'header-list': 'Heading List',
}
